/**
 * author: Ananthapadmanabhan V K
 */
import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import "./StandardsCreate.scss";
import { withTranslation } from "react-i18next";
import { Button, Modal, Form } from "react-bootstrap";
import { RegulationContext } from "../../../../App";
import { StadardReportFrequency, USER_ROLE } from "../../../../core/constants/common";
import StandardService from "../../../../core/service/StandardService";

const StandardsCreate = ({ t, handleCreateCallback, editStandard }) => {
  const { setGlbRegulations } = useContext(RegulationContext);
  var data = JSON.parse(localStorage.getItem("authority"));
  const [show, setShow] = useState(true);
  const [validated, setValidated] = useState(false);
  const [standard, setStandard] = useState(editStandard ? editStandard?.name : "");
  // Default frequency to MONTHLY for new standards
  const [frequency, setFrequency] = useState(editStandard ? editStandard?.frequency : "MONTHLY");
  const [isEdit, setIsEdit] = useState(editStandard ? true : false);
  var isDisabled = data.roles.includes("SUPER_ADMIN") ? "" : "disabled";

  const handleClose = () => {
    setShow(false);
    let obj = {
      val: false,
      type: "STANDARD",
      id: editStandard?.id
    };
    handleCreateCallback(obj);
  };

  const options = StadardReportFrequency({ t });

  const handleCreateStandard = () => {
    if (!standard || !frequency) {
      setShow(true);
    } else {
      setShow(false);
      const params = {
        name: standard.trim(),
        frequency: frequency
      };
      let obj = {
        val: false,
        type: "STANDARD"
      };
      StandardService.createStandard(params, data.roles.includes(USER_ROLE.SUPER_ADMIN))
        .then((response) => {
          if (response.status === 201) {
            setGlbRegulations(response?.data);
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
          handleCreateCallback(obj);
        })
        .catch((error) => {
          handleCreateCallback(obj);
        });
    }
    setValidated(true);
  };
  const handleEditStandard = () => {
    if (!standard || !frequency) {
      setShow(true);
    } else {
      editStandard.name = standard.trim();
      editStandard.frequency = frequency;
      StandardService.updateStandard(editStandard, data.roles.includes(USER_ROLE.SUPER_ADMIN))
        .then((response) => {
          if (response.status === 200) {
            setGlbRegulations(response.data);
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
          let obj = {
            val: false,
            type: "STANDARD",
            id: editStandard?.id
          };
          handleCreateCallback(obj);
        })
        .catch((error) => {
        });
    }
    setValidated(true);
  };

  return (
    <>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          < Modal.Title as="h5">
            {editStandard ? t("EditStandard.label") : t("NewStandard.label")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
            <div className="Single_RC_01">
              <div className="Single_RC_Row01 m-0">
                <div className="p-2">
                  <label className="mb-1">{t("NameOfStandard.label")} <sapn className="text-danger">*</sapn></label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    disabled={isDisabled}
                    value={standard}
                    onChange={(e) => setStandard(e.target.value)}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("ReportingFrequency.label")} <sapn className="text-danger">*</sapn></label>
                  <select
                    className="form-select"
                    disabled={isDisabled}
                    required
                    onChange={(e) => setFrequency(e.target.value)}
                    value={frequency}
                  >
                    <option value="" disabled hidden>
                      {t("Select.label")}
                    </option>
                    {options?.map((items) => (
                      <option value={items.value} key={items.value}>
                        {items.label}
                      </option>
                    ))}
                  </select>
                </div>

              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          {isEdit ? (
            <Button variant="primary" onClick={handleEditStandard} className="sbmBtn">
              {t("Update.label")}
            </Button>
          ) : (
            <Button variant="primary" onClick={handleCreateStandard} className="sbmBtn">
              {t("Create.label")}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
StandardsCreate.propTypes = {
  handleCreateCallback: PropTypes.func.isRequired,
};
export default withTranslation()(StandardsCreate);
